<b>
    <u>A little about the Transaction Fees</u>
</b>
<p>
    Banks and credit card companies charge a fee to process the transaction electronically. Depending on your method of payment, the following fees are levied.
</p>
<p>
    Connected Bank Account (ACH): 1.30% of the amount <br>
    Credit Cards: 2.7% of the amount + $0.30
</p>
<p>
    Typically, the non-profit organization will cover these. However at PayBee, we give donors option to cover transaction fee.
</p>
<p>
    Pollinate goodness!
</p>
